import { render } from "./Modal.vue?vue&type=template&id=701ac82d"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/www.alb-bayern.de/bottle/www/apps/alb_development/frontend/mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Modal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "701ac82d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('701ac82d', __exports__)) {
    console.log('reload')
    api.reload('701ac82d', __exports__)
  }
  
  module.hot.accept("./Modal.vue?vue&type=template&id=701ac82d", () => {
    console.log('re-render')
    api.rerender('701ac82d', render)
  })

}


export default __exports__